import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { productsClient } from "@core/clients";
import { Product } from "@core/types";
import { PRODUCT_QUERY_CACHE_EXPIRE_TIME_MS } from "../../config/constansts";

const useGetProductVariations = (
  variations: (string | number)[],
  zoneId: string,
  options: UseQueryOptions<Product[]> = {},
) => {
  return useQuery<Product[], any>(
    ["product", "variations", variations],
    async () => {
      return await productsClient.getIncludeProducts(variations.map(String), { zoneId });
    },
    {
      cacheTime: PRODUCT_QUERY_CACHE_EXPIRE_TIME_MS,
      staleTime: PRODUCT_QUERY_CACHE_EXPIRE_TIME_MS,
      ...options,
    },
  );
};

export default useGetProductVariations;
